import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Popover } from '@getro/rombo';
import IntegrationPopoverRow from './IntegrationPopoverRow';

const Content = styled.div`
  min-width: 300px;
  max-width: 380px;
`;

const IntegrationsPopover = ({ integrations, memberFirstName, networkSlug, isCurrentUser, trigger }) => (
  <Popover
    interactive
    position="bottom-start"
    trigger={trigger}
    content={
      <Content>
        {integrations.map((integration) => (
          <IntegrationPopoverRow
            key={integration.type}
            integration={integration}
            memberFirstName={memberFirstName}
            networkSlug={networkSlug}
            isCurrentUser={isCurrentUser}
          />
        ))}
      </Content>
    }
  />
);

IntegrationsPopover.propTypes = {
  integrations: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
    }),
  ).isRequired,
  memberFirstName: PropTypes.string.isRequired,
  networkSlug: PropTypes.string.isRequired,
  isCurrentUser: PropTypes.bool.isRequired,
  trigger: PropTypes.node.isRequired,
};

export default IntegrationsPopover;
